module.exports = __webpack_public_path__ + "cf6f881dd4de63d09078ba7d18f885ee.svg";


//////////////////
// WEBPACK FOOTER
// ./images/new-form-white.svg
// module id = 104
// module chunks = 0